__webpack_require__.p = "https://static.age.awaze.com/search-mfe/913976f/_next/";